/* VCTparts: 'Maak je bestelling compleet' bundle on the product page
   (snippets/henk-upsell-products.liquid). Moved out of the snippet so the
   browser caches it; icons and texts come from the #bundle-icons and
   #bundle-i18n JSON blocks in the snippet. */
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.bundle-wrapper');
  if (!wrapper) return;

  let ICON = {};
  try { ICON = JSON.parse(document.getElementById('bundle-icons').textContent) || {}; } catch (e) { ICON = {}; }

  /* ─────────── TAAL ───────────
     Teksten komen uit het Liquid-blok "VERTALINGEN" bovenin dit bestand. */
  // Nederlandse teksten als vangnet: exact de oorspronkelijke NL-versie.
  const I18N_NL = {
    lang: 'nl', change: 'Wijzig', more_info: 'Meer info', chosen: 'Gekozen',
    deal_tag: '{pay}+{free} gratis', deal_title: 'Neem er {qty}, betaal er {pay}',
    deal_save: 'Bespaar {amount}', lock_note: 'De bundelkorting vervalt zolang {deal} is geselecteerd.',
    error: 'Er ging iets mis bij het toevoegen. Probeer het opnieuw.', round_suffix: ',-'
  };
  let I18N = Object.assign({}, I18N_NL);
  try {
    const iEl = document.getElementById('bundle-i18n');
    if (iEl) I18N = Object.assign({}, I18N_NL, JSON.parse(iEl.textContent) || {});
  } catch (e) { I18N = Object.assign({}, I18N_NL); }
  const IS_NL = (I18N.lang || 'nl') === 'nl';

  function t(key, vars) {
    let s = I18N[key] != null ? String(I18N[key]) : '';
    if (vars) Object.keys(vars).forEach(k => { s = s.split('{' + k + '}').join(String(vars[k])); });
    return s;
  }

  /* Locale-root: "/" op vctparts.nl / vctparts.de, "/fr/" op vctparts.be/fr.
     Alle eigen fetches en productlinks lopen hierlangs, zodat taal én markt
     (prijzen) behouden blijven. */
  const ROOT = (wrapper.dataset.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

  const container        = wrapper.querySelector('.bundle-recommendations-container');
  const dealContainer    = wrapper.querySelector('.bundle-deal-container');
  const baseUrl          = wrapper.dataset.url;
  const complementaryUrl = baseUrl + '&intent=complementary';
  let   productForm      = null;   // wordt gezet door findMainForm()

  const altOverlay = document.getElementById('bundle-alt-overlay');
  const altModal   = altOverlay.querySelector('.bundle-alt-modal');
  const altGrid    = document.getElementById('bundle-alt-grid');
  const altClose   = document.getElementById('bundle-alt-close');

  if (altOverlay && altOverlay.parentElement !== document.body) document.body.appendChild(altOverlay);

  const VISIBLE_SLOTS = 2;
  const TARGET_MIN    = 40;   // streef naar 40 producten → 35+ alternatieven in de popup

  /* ── 2+1 gratis instellingen ── */
  const DEAL_ON   = wrapper.dataset.deal === 'true' && !!dealContainer;
  const DEAL_QTY  = 3;   // aantal stuks dat in de mand gaat
  const DEAL_PAY  = 2;   // aantal stuks dat betaald wordt
  let   dealChecked = false;

  /* ─────────── MERKSLOT ───────────
     Staat het hoofdproduct onder een van deze merken, dan mogen ALLEEN
     producten van datzelfde merk in de pool. De pool voedt zowel de zichtbare
     kaartjes als de "Wijzig"-popup, dus de klant krijgt nergens een ander merk
     te zien. Nieuw merk toevoegen? Zet de handle er hier gewoon bij, bijv.
     ['glossio', 'ander-merk'].
     Herkenning op vendor + titel + URL. De merknaam wordt niet vertaald, dus
     dit werkt in alle talen. */
  const BRAND_LOCKS = ['glossio'];

  const MAIN_VENDOR_LC = (wrapper.dataset.mainVendor || '').toLowerCase();
  const MAIN_TITLE_LC  = (wrapper.dataset.mainTitle  || '').toLowerCase();
  const MAIN_HANDLE_LC = (wrapper.dataset.mainHandle || '').toLowerCase();

  const LOCKED_BRAND = BRAND_LOCKS.filter(function (b) {
    return MAIN_VENDOR_LC.indexOf(b) !== -1 ||
           MAIN_TITLE_LC.indexOf(b)  !== -1 ||
           MAIN_HANDLE_LC.indexOf(b) !== -1;
  })[0] || null;

  function isBrandMatch(d) {
    if (!LOCKED_BRAND) return true;   // geen merkslot → alles mag
    const hay = ((d.vendor || '') + ' ' + (d.title || '') + ' ' + (d.url || '')).toLowerCase();
    return hay.indexOf(LOCKED_BRAND) !== -1;
  }

  /* ─────────── UITSLUITINGEN ───────────
     Grootverpakkingen (25 liter vaten/jerrycans) nooit aanraden in de upsell.
     Er moet ZOWEL '25 liter' als een vat-aanduiding in staan, zodat een
     onschuldige 25L-artikel (bijv. een dakkoffertas van 25 liter) gewoon
     aanbevolen mag blijven worden.
     Meertalig: liter/litre(s) + NL vat/jerrycan, DE Kanister/Fass/Gebinde,
     FR bidon/jerrican/fût/grand conditionnement.
     Let op: '1,25L' of '125L' wordt niet geraakt, alleen echte 25 liter.
     'Fass' staat met woordgrenzen, zodat 'Fassung' (lampvoet) NIET geraakt wordt. */
  const EXCLUDE_SIZE = /(^|[^\d.,])25\s*[-.]?\s*(l|ltr|lt|liter|litre)s?\b/i;
  // NL: exact de oorspronkelijke regel. DE/FR: aangevuld met vertaalde woorden.
  const EXCLUDE_BULK = IS_NL
    ? /jerrycan|grootverpakking|\bvat\b|\bvaten\b/i
    : /jerrycan|jerrican|grootverpakking|\bvat\b|\bvaten\b|kanister|gebinde|\bfass\b|\bf(ä|ae)sser\b|bidon|\bf(û|u)ts?\b|tonneau|grand[\s-]+conditionnement/i;

  function isExcluded(d) {
    const hay = (d.title || '') + ' ' + (d.url || '');
    return EXCLUDE_SIZE.test(hay) && EXCLUDE_BULK.test(hay);
  }

  // Eén poort waar elk product doorheen moet voordat het in de pool komt.
  function isAllowed(d) {
    if (!d || !d.variantId) return false;
    if (isExcluded(d)) return false;
    if (!isBrandMatch(d)) return false;
    return true;
  }

  /* ─────────── GEEN CONCURRENTEN ───────────
     "Maak je bundel compleet" vult aan; het stelt geen tweede exemplaar van
     hetzelfde soort product voor. Valt af (behalve voorkeurs- en handmatige
     Search & Discovery-producten):
     - producten uit de hoofdcategorie van dit product (de kleinste echte
       collectie waar het in zit, zie mainCategory());
     - producten met hetzelfde producttype (alleen als dat type geen merknaam
       is; de Liquid laat het anders leeg);
     - bij een LED-lamp: elke andere LED-lamp (H7 naast H7, maar ook H4). */
  const IS_LED       = wrapper.dataset.led === 'true';
  const EXCLUDE_TYPE = (wrapper.dataset.excludeType || '').trim().toLowerCase();
  const LED_FITS     = /(^|[^a-z0-9])(h1|h3|h4|h7|h8|h9|h11|h13|h15|h16|h18|h19|hb3|hb4|hb5|hir2|9005|9006|9012|d[1-58][sr])([^a-z0-9]|$)/i;
  const ACCESSORY    = /decoder|(^|[^a-z])adapter([^a-z]|$)|adaptateur|condensat|kondensator|relais|houder|halterung|kabel|c[âa]ble|tester/i;
  const RESISTOR     = /weerstand|widerstand|r[ée]sistance/i;
  const LAMP_WORD    = /lamp|birne|ampoule/i;
  function looksLikeLedLamp(title) {
    const t = String(title || '');
    if (!/(^|[^a-z])led/i.test(t) || !LED_FITS.test(t)) return false;
    if (ACCESSORY.test(t)) return false;
    if (RESISTOR.test(t) && !LAMP_WORD.test(t)) return false;
    return true;
  }
  let blockIds = new Set();   // product-ID's uit de hoofdcategorie
  function isCompetitor(d) {
    if (d.productId && blockIds.has(String(d.productId))) return true;
    if (EXCLUDE_TYPE && (d.type || '').trim().toLowerCase() === EXCLUDE_TYPE) return true;
    if (IS_LED && looksLikeLedLamp(d.title)) return true;
    return false;
  }

  // Hoofdcategorie: kleinste collectie van dit product met 2–300 producten, zonder junk- en merkcollecties.
  function mainCategory() {
    const BAD = /^(all|all-products.*|alle-producten|alle-produkte|tous-les-produits|aanbiedingen|eol|orderly.*|tryon.*|nada.*)$/i;
    const NUM = /^<?\d+(-\d+)?$/;
    const vendorHandle = MAIN_VENDOR_LC.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const cats = (wrapper.dataset.cats || '').split('|').map(chunk => {
      const i = chunk.lastIndexOf(':');
      if (i < 0) return null;
      return { handle: chunk.slice(0, i).trim(), count: parseInt(chunk.slice(i + 1), 10) || 0 };
    }).filter(c => c && c.handle && c.count > 1 && c.count <= 300 && !BAD.test(c.handle) && !NUM.test(c.handle) && c.handle !== vendorHandle && (!LOCKED_BRAND || c.handle.indexOf(LOCKED_BRAND) === -1));
    cats.sort((a, b) => a.count - b.count);
    return cats[0] || null;
  }
  function fetchCategoryIds(handle) {
    return fetch(ROOT + 'collections/' + handle + '/products.json?limit=250')
      .then(r => r.ok ? r.json() : { products: [] })
      .then(j => new Set((j.products || []).map(p => String(p.id))))
      .catch(() => new Set());
  }

  const MAIN_CAT = mainCategory();

  // Voorkeursproducten en vaste add-ons (inbouwservice) uit de Liquid
  let PREFERRED = [];
  try { PREFERRED = JSON.parse((document.getElementById('bundle-preferred') || {}).textContent || '[]') || []; } catch (e) { PREFERRED = []; }
  let ADDONS = [];
  try { ADDONS = JSON.parse((document.getElementById('bundle-addons') || {}).textContent || '[]') || []; } catch (e) { ADDONS = []; }
  const addonChecked = {};

  /* ── Varianten van HET HOOFDPRODUCT (whitelist + prijzen) ── */
  let mainVariants = {};
  try {
    const vEl = document.getElementById('bundle-main-variants');
    if (vEl) mainVariants = JSON.parse(vEl.textContent) || {};
  } catch (e) { mainVariants = {}; }
  const MAIN_VARIANT_IDS = Object.keys(mainVariants);

  // Hoort dit variant-ID bij het product van deze pagina?
  function isOwnVariant(id) {
    if (!id) return false;
    if (!MAIN_VARIANT_IDS.length) return String(id) === String(wrapper.dataset.mainVariant || '');
    return MAIN_VARIANT_IDS.indexOf(String(id)) !== -1;
  }

  /* Zoek het formulier van HET HOOFDPRODUCT.
     document.querySelector('form[action*="/cart/add"]') is niet betrouwbaar: op een
     productpagina staan ook quick-add formulieren van aanbevolen producten, en die
     kunnen eerder in de DOM staan. Daarom accepteren we alleen een formulier waarvan
     het id-veld een variant van DIT product bevat.
     (action*="/cart/add" matcht ook "/fr/cart/add".) */
  function findMainForm() {
    if (productForm && document.contains(productForm)) {
      const cached = productForm.querySelector('input[name="id"][type="hidden"]') || productForm.querySelector('[name="id"]');
      if (cached && cached.value && isOwnVariant(cached.value)) return productForm;
    }
    const forms = [];
    const own = wrapper.closest('form[action*="/cart/add"]');
    if (own) forms.push(own);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(f => { if (forms.indexOf(f) === -1) forms.push(f); });
    for (const f of forms) {
      const el = f.querySelector('input[name="id"][type="hidden"]') || f.querySelector('[name="id"]');
      if (el && el.value && isOwnVariant(el.value)) { productForm = f; return f; }
    }
    productForm = own || null;
    return productForm;
  }

  /* ── ENIGE BRON VAN WAARHEID ──
     allCards : alle beschikbare producten (data-objecten met variantId + basisprijs)
     slots    : [{ index, checked }] per zichtbaar vak. Alles leest hieruit. */
  let allCards = [];
  let slots = [];

  // Stukprijzen (centen) van bundel/upsell-producten die AL in de winkelmand zitten
  let cartBundleUnitPrices = [];

  // NL/DE: 12,50 / 12,-   FR: 12,50 / 12,00  (suffix per taal, zie VERTALINGEN)
  const ROUND_SUFFIX = I18N.round_suffix != null ? String(I18N.round_suffix) : ',-';
  function money(cents) {
    const n = parseInt(cents);
    if (!n || isNaN(n)) return '';
    return (n / 100).toFixed(2).replace('.', ',').replace(/,00$/, ROUND_SUFFIX);
  }

  function escHtml(s) {
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ── Bundel-trapkorting: #1 (duurste) = 0%, #2 = 5%, #3+ = 10% ──
  function tierPct(rank) {
    if (rank <= 0) return 0;
    if (rank === 1) return 5;
    return 10;
  }

  // Ken kortingspercentages toe via stabiele sortering (duurste eerst).
  // list: [{ price, key }]  → returns { key: pct }
  function assignTiers(list) {
    const map = {};
    list.map((x, i) => ({ x, i }))
        .sort((a, b) => (b.x.price - a.x.price) || (a.i - b.i))
        .forEach((e, rank) => { map[e.x.key] = tierPct(rank); });
    return map;
  }

  /* Geeft ALTIJD een variant van dit product terug — nooit die van een
     aanbevolen product. Volgorde: eigen formulier → elk id-veld op de pagina dat
     bij dit product hoort → de door Liquid gerenderde variant. */
  function getMainVariantId() {
    const form = findMainForm();
    if (form) {
      const el = form.querySelector('input[name="id"][type="hidden"]') || form.querySelector('[name="id"]');
      if (el && el.value && isOwnVariant(el.value)) return String(el.value);
    }
    const fields = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (const el of fields) {
      if (el.value && isOwnVariant(el.value)) return String(el.value);
    }
    const liquidVariant = wrapper.dataset.mainVariant;
    if (liquidVariant) return String(liquidVariant);
    return null;
  }

  // Prijs van de op dit moment gekozen variant (valt terug op de Liquid-waarde).
  function getMainPrice() {
    const vid = getMainVariantId();
    if (vid && mainVariants[vid] && mainVariants[vid].price) return parseInt(mainVariants[vid].price) || 0;
    return parseInt(wrapper.dataset.mainPrice) || 0;
  }

  function getMainImg() {
    const vid = getMainVariantId();
    if (vid && mainVariants[vid] && mainVariants[vid].img) return mainVariants[vid].img;
    return wrapper.dataset.mainImg || '';
  }

  function slotBase(i) {
    const d = allCards[slots[i].index];
    return d ? (parseInt(d.price) || 0) : 0;
  }

  /* ── Databronnen (zonder korting; alleen basisprijs) ── */
  function cardFromEl(c) {
    return {
      productId : c.dataset.productId ? String(c.dataset.productId) : '',
      type      : c.dataset.type || '',
      variantId : c.dataset.variantId ? String(c.dataset.variantId) : '',
      price     : c.dataset.price,   // basisprijs in centen
      title     : c.dataset.title,
      vendor    : c.dataset.vendor,
      url       : c.dataset.url,
      img       : c.dataset.img
    };
  }

  // Aanbevelingen uit de section-render (max 10 per intent). URL is al gelokaliseerd.
  function parseRecommendations(url) {
    return fetch(url)
      .then(r => r.text())
      .then(text => {
        const el = document.createElement('div');
        el.innerHTML = text;
        return Array.from(el.querySelectorAll('.bundle-card')).map(cardFromEl);
      })
      .catch(() => []);
  }

  // Product uit <root>collections/<handle>/products.json omzetten naar een kaart (basisprijs).
  function cardFromJson(p) {
    if (!p || String(p.id) === String(wrapper.dataset.mainProduct)) return null;
    const v = p.variants && p.variants[0];
    if (!v || v.available === false) return null;
    const baseCents = Math.round(parseFloat(v.price) * 100);
    if (!baseCents) return null;
    let img = '';
    if (p.images && p.images[0]) img = (typeof p.images[0] === 'string') ? p.images[0] : p.images[0].src;
    return {
      productId : String(p.id),
      type      : p.product_type || '',
      variantId : String(v.id),
      price     : String(baseCents),
      title     : p.title,
      vendor    : p.vendor,
      url       : ROOT + 'products/' + p.handle,
      img       : img
    };
  }

  function fetchCollection(handle) {
    return fetch(ROOT + 'collections/' + handle + '/products.json?limit=50')
      .then(r => r.ok ? r.json() : { products: [] })
      .then(j => (j.products || []).map(cardFromJson).filter(Boolean))
      .catch(() => []);
  }

  function goodHandles() {
    const BAD = /^(all|all-products.*|alle-producten|alle-produkte|tous-les-produits|orderly.*|tryon.*)$/i;
    const NUM = /^<?\d+(-\d+)?$/;
    const list = (wrapper.dataset.poolCollections || '')
      .split(',').map(s => s.trim()).filter(Boolean)
      .filter(h => !BAD.test(h) && !NUM.test(h))
      .filter(h => !MAIN_CAT || h !== MAIN_CAT.handle);   // eigen hoofdcategorie = concurrenten

    if (!LOCKED_BRAND) return list;

    // Bij een merkslot eerst de merkcollecties afgrazen; die leveren gegarandeerd
    // bruikbare producten, de rest wordt er toch uitgefilterd.
    const brandFirst = list.filter(h => h.indexOf(LOCKED_BRAND) !== -1);
    const rest       = list.filter(h => h.indexOf(LOCKED_BRAND) === -1);
    const out        = brandFirst.concat(rest);

    // Vangnet: de merkcollectie zelf, ook als het product er (nog) niet in zit.
    if (out.indexOf(LOCKED_BRAND) === -1) out.push(LOCKED_BRAND);
    return out;
  }

  // Lees de winkelmand: stukprijzen van bundel/upsell-producten (property _bundle of _upsell).
  function loadCartBundle() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        cartBundleUnitPrices = [];
        (cart.items || []).forEach(line => {
          const props = line.properties || {};
          const isBundle = props._bundle === 'true' || props._bundle === true ||
                           props._upsell === 'true' || props._upsell === true;
          if (!isBundle) return;
          const unit = parseInt(line.original_price != null ? line.original_price : line.price) || 0;
          const qty = parseInt(line.quantity) || 0;
          for (let q = 0; q < qty; q++) cartBundleUnitPrices.push(unit);
        });
      })
      .catch(() => { cartBundleUnitPrices = []; });
  }

  /* ── Kortingsberekening per zichtbaar vak ──
     Basispool = winkelmand-bundelitems + hoofdproduct + AANGEVINKTE upsells.
     - Aangevinkt vak: rang binnen de basispool.
     - Onaangevinkt vak: rang die het zou krijgen als je het NU toevoegt
       (basispool + dit product), zodat de klant ziet "voeg toe voor -X%". */
  function computeDisplayPcts() {
    const base = [];
    cartBundleUnitPrices.forEach((p, idx) => base.push({ price: p, key: 'cart' + idx }));
    base.push({ price: getMainPrice(), key: 'main' });
    slots.forEach((s, i) => { if (s.checked) base.push({ price: slotBase(i), key: 'slot' + i }); });

    const checkedMap = assignTiers(base);

    return slots.map((s, i) => {
      if (s.checked) return checkedMap['slot' + i];
      const preview = base.concat([{ price: slotBase(i), key: 'preview' }]);
      return assignTiers(preview)['preview'];
    });
  }

  // Werk de zichtbare prijzen/badges bij aan de hand van de huidige ranking.
  function refreshPrices() {
    const pcts = computeDisplayPcts();
    // Alleen de slot-kaartjes; het 2+1-kaartje heeft geen data-slot en doet niet mee.
    const cards = container.querySelectorAll('.bundle-card[data-slot]');
    cards.forEach((card, i) => {
      const base = slotBase(i);
      const pct = pcts[i] || 0;
      const disc = Math.round(base * (100 - pct) / 100);

      const cur = card.querySelector('.price-current');
      if (cur) cur.textContent = money(pct > 0 ? disc : base);

      const old = card.querySelector('.price-old');
      if (old) {
        if (pct > 0) { old.textContent = money(base); old.style.display = ''; }
        else { old.textContent = ''; old.style.display = 'none'; }
      }

      const badge = card.querySelector('.discount-badge');
      if (badge) {
        badge.textContent = '-' + pct + '%';
        badge.style.display = pct > 0 ? '' : 'none';
      }
    });
  }

  /* ── Eén vak renderen uit state ── */
  function buildCard(slotIndex) {
    const slot = slots[slotIndex];
    const d = allCards[slot.index];
    const base = parseInt(d.price) || 0;

    const card = document.createElement('div');
    card.className = 'bundle-card recommended-product' + (slot.checked ? ' is-checked' : '');
    card.dataset.slot = String(slotIndex);

    card.innerHTML = `
      <div class="bundle-checkbox-wrapper">
        <label class="bundle-custom-checkbox" onclick="event.stopPropagation()">
          <input type="checkbox" class="bundle-checkbox add-on-checkbox" ${slot.checked ? 'checked' : ''} aria-label="${escHtml(d.title)}">
          <span class="bundle-checkmark">${ICON.check}</span>
        </label>
      </div>
      <a href="${escHtml(d.url)}" class="bundle-image-wrap" onclick="event.stopPropagation()">
        <img src="${escHtml(d.img)}" alt="${escHtml(d.title)}" loading="lazy">
      </a>
      <div class="bundle-info">
        <div class="bundle-title">${escHtml(d.title)}</div>
        <div class="bundle-prices">
          <span class="price-current">${money(base)}</span>
          <span class="price-old" style="display:none;"></span>
          <span class="discount-badge vct-badge vct-badge--danger" style="display:none;">-0%</span>
        </div>
      </div>
      <div class="bundle-actions">
        <a href="${escHtml(d.url)}" class="bundle-info-btn bundle-icon-link" title="${escHtml(t('more_info'))}" aria-label="${escHtml(t('more_info'))}" onclick="event.stopPropagation()">
          <span class="info-circle">${ICON.info}</span>
        </a>
        <button type="button" class="bundle-alt-btn vct-btn vct-btn--ghost">
          ${escHtml(t('change'))}
          ${ICON.chevron}
        </button>
      </div>`;

    const cb = card.querySelector('.bundle-checkbox');
    function setChecked(v) {
      slots[slotIndex].checked = v;
      cb.checked = v;
      card.classList.toggle('is-checked', v);
      refreshPrices();
    }

    card.querySelector('.bundle-alt-btn').addEventListener('click', e => { e.stopPropagation(); showAltPanel(slotIndex); });
    cb.addEventListener('change', () => setChecked(cb.checked));
    card.addEventListener('click', function (e) {
      if (e.target.closest('.bundle-alt-btn')) return;
      if (e.target.closest('.bundle-icon-link')) return;
      if (e.target.closest('.bundle-image-wrap')) return;
      if (e.target.closest('.bundle-custom-checkbox')) return;
      setChecked(!slots[slotIndex].checked);
    });

    return card;
  }

  function renderSlots() {
    container.innerHTML = '';
    slots.forEach((_, i) => container.appendChild(buildCard(i)));
    if (allCards.length <= slots.length) {
      container.querySelectorAll('.bundle-alt-btn').forEach(b => b.style.display = 'none');
    }
    refreshPrices();
  }

  /* ─────────── 3e rijtje: 2+1 gratis ───────────
     Zelfde kaart-stijl. Aanvinken = DEAL_QTY stuks van het hoofdproduct in de
     mand; de automatische Shopify-korting maakt er 1 gratis. Sluit de
     bundelkorting uit (upsell-kaartjes gaan uit en worden geblokkeerd). */

  function dealPct() { return Math.round((1 - DEAL_PAY / DEAL_QTY) * 100); }

  function dealTagText() {
    return t('deal_tag', { pay: DEAL_PAY, free: DEAL_QTY - DEAL_PAY, qty: DEAL_QTY });
  }

  function renderDealCard() {
    if (!DEAL_ON) return;

    const unit  = getMainPrice();
    const full  = unit * DEAL_QTY;
    const pay   = unit * DEAL_PAY;
    const save  = full - pay;
    const title = wrapper.dataset.mainTitle || '';

    dealContainer.innerHTML = '';

    const card = document.createElement('div');
    card.className = 'bundle-card bundle-deal-card' + (dealChecked ? ' is-checked' : '');
    card.innerHTML = `
      <div class="bundle-checkbox-wrapper">
        <label class="bundle-custom-checkbox" onclick="event.stopPropagation()">
          <input type="checkbox" class="bundle-deal-checkbox" ${dealChecked ? 'checked' : ''} aria-label="${escHtml(t('deal_title', { qty: DEAL_QTY, pay: DEAL_PAY, free: DEAL_QTY - DEAL_PAY }))}">
          <span class="bundle-checkmark">${ICON.check}</span>
        </label>
      </div>
      <span class="bundle-image-wrap">
        <img src="${escHtml(getMainImg())}" alt="${escHtml(title)}" loading="lazy">
      </span>
      <div class="bundle-info">
        <div class="bundle-deal-tagrow">
          <span class="bundle-deal-tag">${escHtml(dealTagText())}</span>
          <span class="bundle-title">${escHtml(t('deal_title', { qty: DEAL_QTY, pay: DEAL_PAY, free: DEAL_QTY - DEAL_PAY }))}</span>
        </div>
        <div class="bundle-deal-sub">${DEAL_QTY}× ${escHtml(title)}</div>
        <div class="bundle-prices">
          <span class="price-current">${money(pay)}</span>
          <span class="price-old">${money(full)}</span>
          <span class="discount-badge vct-badge vct-badge--danger">-${dealPct()}%</span>
        </div>
      </div>
      <div class="bundle-actions" style="justify-content:center;">
        <span class="bundle-deal-save vct-badge vct-badge--success">${escHtml(t('deal_save', { amount: money(save) }))}</span>
      </div>`;

    const cb = card.querySelector('.bundle-deal-checkbox');
    cb.addEventListener('change', () => setDeal(cb.checked));
    card.addEventListener('click', function (e) {
      if (e.target.closest('.bundle-custom-checkbox')) return;
      setDeal(!dealChecked);
    });

    const note = document.createElement('div');
    note.className = 'bundle-lock-note' + (dealChecked ? ' is-visible' : '');
    note.textContent = t('lock_note', { deal: dealTagText() });

    dealContainer.appendChild(card);
    dealContainer.appendChild(note);
  }

  function setDeal(v) {
    dealChecked = !!v;
    if (dealChecked) slots.forEach(s => { s.checked = false; });
    if (container) container.classList.toggle('is-locked', dealChecked);
    if (slots.length) renderSlots();
    renderDealCard();
  }

  // Prijs/afbeelding meelaten bewegen met de gekozen variant.
  function onVariantChange() {
    if (!DEAL_ON) return;
    renderDealCard();
    if (slots.length) refreshPrices();
  }

  function watchVariant() {
    if (!DEAL_ON) return;
    const form = findMainForm();
    if (!form) return;
    form.addEventListener('change', () => setTimeout(onVariantChange, 60));
    const idInput = form.querySelector('[name="id"]');
    if (idInput && window.MutationObserver) {
      new MutationObserver(() => onVariantChange())
        .observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }
    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('variantChange', onVariantChange);
  }

  /* ─────────── Vaste add-ons (inbouwservice) ───────────
     Zelfde kaart-stijl en vinkje als de aanbevelingen. Gaat met property
     _addon mee in de mand, los van de bundelkorting. */
  function renderAddons() {
    const box = wrapper.querySelector('.bundle-addon-container');
    if (!box || !ADDONS.length) return;
    box.innerHTML = '';
    ADDONS.forEach(a => {
      if (!a || !a.variantId) return;
      const key = String(a.key || a.variantId);
      const on = !!addonChecked[key];
      const card = document.createElement('div');
      card.className = 'bundle-card bundle-addon-card' + (on ? ' is-checked' : '');
      card.innerHTML = `
        <div class="bundle-checkbox-wrapper">
          <label class="bundle-custom-checkbox" onclick="event.stopPropagation()">
            <input type="checkbox" class="bundle-addon-checkbox" ${on ? 'checked' : ''} aria-label="${escHtml(a.title)}">
            <span class="bundle-checkmark">${ICON.check}</span>
          </label>
        </div>
        <span class="bundle-image-wrap"><span class="bundle-addon-icon">${ICON.wrench || ''}</span></span>
        <div class="bundle-info">
          <div class="bundle-title">${escHtml(a.title)}</div>
          <div class="bundle-addon-sub">${escHtml(a.sub || '')}</div>
          <div class="bundle-prices"><span class="price-current">${escHtml(a.priceLabel || '')}</span></div>
        </div>
        <div class="bundle-actions">
          ${a.url ? `<a href="${escHtml(a.url)}" class="bundle-info-btn bundle-icon-link" target="_blank" rel="noopener" title="${escHtml(t('more_info'))}" aria-label="${escHtml(t('more_info'))}" onclick="event.stopPropagation()"><span class="info-circle">${ICON.info}</span></a>` : ''}
        </div>`;
      const cb = card.querySelector('.bundle-addon-checkbox');
      function set(v) { addonChecked[key] = v; cb.checked = v; card.classList.toggle('is-checked', v); }
      cb.addEventListener('change', () => set(cb.checked));
      card.addEventListener('click', e => {
        if (e.target.closest('.bundle-custom-checkbox') || e.target.closest('.bundle-icon-link')) return;
        set(!addonChecked[key]);
      });
      box.appendChild(card);
    });
  }
  function addonItems() {
    return ADDONS.filter(a => a && a.variantId && addonChecked[String(a.key || a.variantId)])
      .map(a => ({ id: String(a.variantId), quantity: 1, properties: { _addon: String(a.key || 'addon') } }));
  }

  /* ── Popup ── */
  let altReturnFocus = null;   // knop die de popup opende; krijgt de focus terug bij sluiten
  function openAlt() {
    altReturnFocus = document.activeElement;
    altOverlay.style.display = 'flex';
    altOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    void altOverlay.offsetWidth;
    altOverlay.classList.add('is-open');
    // Toetsenbordfocus in de popup zetten, anders tabt men achter de overlay verder.
    altClose.focus({ preventScroll: true });
  }
  function closeAlt() {
    altOverlay.classList.remove('is-open');
    altOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => { altOverlay.style.display = 'none'; }, 200);
    if (altReturnFocus && document.contains(altReturnFocus)) altReturnFocus.focus({ preventScroll: true });
    altReturnFocus = null;
  }

  /* De popup leest uit dezelfde allCards-pool, die al door isAllowed() is
     gefilterd. Extra check hieronder is een vangnet, mocht er ooit een andere
     bron aan de pool worden toegevoegd. */
  /* Volgorde in de popup: eerst het gekozen product, dan de logische
     vervangers voor díe plek. Punten voor dezelfde soort lamp (koplamp of
     klein lampje), overlap in de productnaam (hetzelfde soort product) en
     hetzelfde merk; bij gelijke punten de prijs die het dichtst bij de
     huidige ligt. Zo staan bij een H1-koplamp eerst de andere koplampen,
     niet een canbus-weerstand of een remlicht. */
  const HEAD_FITS  = /\b(H1|H3|H4|H7|H8|H9|H11|H13|H15|H16|H18|H19|HB3|HB4|HB5|HIR2|9005|9006|9012|D1S|D1R|D2S|D2R|D3S|D4S)\b/i;
  const SMALL_FITS = /\b(T10|T15|T20|W5W|W16W|W21W|P21W|PY21W|P21\/5W|BA15S|BAU15S|BAY15D|C5W|C10W|H6W|H21W|R5W|R10W)\b/i;
  const STOP_WORDS = new Set(['de', 'het', 'een', 'en', 'met', 'voor', 'van', 'tot', 'set', 'stuk', 'stuks', 'led', 'the', 'and', 'for', 'with', 'mit', 'und', 'für', 'pour', 'avec', 'les', 'des']);
  function lampKind(title) {
    const s = String(title || '');
    if (HEAD_FITS.test(s)) return 'head';
    if (SMALL_FITS.test(s)) return 'small';
    return '';
  }
  function titleWords(title) {
    return new Set(String(title || '').toLowerCase()
      .replace(/[^a-z0-9äöüßéèêëàâçïîôû]+/g, ' ').split(' ')
      .filter(w => w.length > 2 && !STOP_WORDS.has(w) && !/^\d+$/.test(w)));
  }
  function altOrder(slotIndex) {
    const curIdx = slots[slotIndex].index;
    const cur = allCards[curIdx] || {};
    const curPrice = parseInt(cur.price) || 0;
    const curKind = lampKind(cur.title);
    const curWords = titleWords(cur.title);
    const curVendor = (cur.vendor || '').toLowerCase();
    function score(d) {
      let s = 0;
      if (curKind && lampKind(d.title) === curKind) s -= 400;
      const words = titleWords(d.title);
      let common = 0;
      words.forEach(w => { if (curWords.has(w)) common++; });
      const union = words.size + curWords.size - common;
      if (union) s -= Math.round(300 * common / union);
      if (curVendor && (d.vendor || '').toLowerCase() === curVendor) s -= 60;
      return s + Math.min(99, Math.abs((parseInt(d.price) || 0) - curPrice) / 100);
    }
    return allCards
      .map((d, i) => ({ d, i, s: i === curIdx ? -1e9 : score(d) }))
      .sort((a, b) => (a.s - b.s) || (a.i - b.i));
  }

  function showAltPanel(slotIndex) {
    altGrid.innerHTML = '';
    altGrid.scrollTop = 0;

    altOrder(slotIndex).forEach(({ d, i }) => {
      const usedElsewhere = slots.some((s, si) => s.index === i && si !== slotIndex);
      if (usedElsewhere) return;
      if (!isAllowed(d)) return;
      const isCurrent = slots[slotIndex].index === i;
      const el = document.createElement('div');
      el.className = 'bundle-alt-card' + (isCurrent ? ' bundle-alt-card--active' : '');
      el.innerHTML = `
        <span class="bundle-alt-active-tag">
          ${ICON.check}
          ${escHtml(t('chosen'))}
        </span>
        <img src="${escHtml(d.img)}" alt="${escHtml(d.title)}" loading="lazy">
        <span class="bundle-alt-vendor">${escHtml(d.vendor)}</span>
        <span class="bundle-alt-title">${escHtml(d.title)}</span>
        <div class="bundle-alt-prices">
          <span class="price-current">${money(d.price)}</span>
        </div>`;
      if (!isCurrent) {
        el.addEventListener('click', () => swapSlot(slotIndex, i));
        // Ook met het toetsenbord te kiezen (Enter/spatie), net als een knop.
        el.tabIndex = 0;
        el.setAttribute('role', 'button');
        el.addEventListener('keydown', e => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          swapSlot(slotIndex, i);
          const again = container.querySelector('.bundle-card[data-slot="' + slotIndex + '"] .bundle-alt-btn');
          if (again) again.focus({ preventScroll: true });
        });
      }
      altGrid.appendChild(el);
    });

    openAlt();
  }

  function swapSlot(slotIndex, newIndex) {
    slots[slotIndex].index = newIndex;   // checked blijft
    renderSlots();
    closeAlt();
  }

  altClose.addEventListener('click', closeAlt);
  altClose.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeAlt(); } });
  altOverlay.addEventListener('click', e => { if (!altModal.contains(e.target)) closeAlt(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && altOverlay.classList.contains('is-open')) closeAlt(); });

  /* ── Laden (aanbevelingen + collectie-aanvulling tot 20+) ── */
  (async function load() {
    // 2+1-rij meteen tonen; die is niet afhankelijk van de aanbevelingen.
    if (DEAL_ON) { renderDealCard(); watchVariant(); }

    renderAddons();

    const mainId = String(getMainVariantId() || '');
    const mainProductId = String(wrapper.dataset.mainProduct || '');
    const seen = new Set();
    // strict = concurrenten weren (niet voor voorkeurs- en handmatige aanvullingen)
    function push(arr, strict) {
      for (const d of arr) {
        if (!d || !d.variantId) continue;
        if (d.variantId === mainId) continue;
        if (d.productId && d.productId === mainProductId) continue;
        if (isOwnVariant(d.variantId)) continue;
        if (seen.has(d.variantId)) continue;
        if (!isAllowed(d)) continue;          // merkslot + 25L-uitsluiting
        if (strict && isCompetitor(d)) continue;
        seen.add(d.variantId);
        allCards.push(d);
      }
    }

    try {
      // 1. Voorkeur (metaveld custom.aanvullingen of de decoder bij een LED-lamp)
      push(PREFERRED.map(d => Object.assign({}, d, { variantId: String(d.variantId), productId: String(d.productId || '') })), false);   // url uit Liquid is al gelokaliseerd
      if (MAIN_CAT) blockIds = await fetchCategoryIds(MAIN_CAT.handle);
      const [comp, std] = await Promise.all([parseRecommendations(complementaryUrl), parseRecommendations(baseUrl)]);
      // 2. Handmatig in Search & Discovery (nooit filteren), 3. gewone aanbevelingen (wel filteren)
      push(comp, false); push(std, true);

      // Aanvullen met collectie-producten tot we >= TARGET_MIN hebben.
      for (const h of goodHandles()) {
        if (allCards.length >= TARGET_MIN) break;
        push(await fetchCollection(h), true);
      }

      // Huidige winkelmand inlezen voor de ranking.
      await loadCartBundle();
    } catch (e) {
      console.error('Upsell laadfout:', e);
    }

    if (allCards.length === 0) {
      if (container) container.style.display = 'none';
      // Alleen alles verbergen als er ook geen 2+1-rij of inbouwservice is.
      if (!DEAL_ON && !ADDONS.length) wrapper.style.display = 'none';
      return;
    }

    const count = Math.min(VISIBLE_SLOTS, allCards.length);
    slots = [];
    for (let i = 0; i < count; i++) slots.push({ index: i, checked: false });
    renderSlots();
    if (DEAL_ON) renderDealCard();   // prijzen kloppen nu ook met de gekozen variant
  })();

  /* ─────────── Toevoegen aan winkelwagen ───────────
     De sticky winkelwagenbalk staat BUITEN het productformulier. Daarom vangen
     we de klik/submit af op WINDOW (capture) — dat draait vóór álle thema-
     listeners, ongeacht welke knop. Hoofdproduct + upsells gaan atomisch in de
     mand; de drawer opent PAS daarna. Variant-ID's komen 100% uit de state. */

  function hasCheckedAddons() { return dealChecked || slots.some(s => s.checked) || addonItems().length > 0; }

  function mainQuantity() {
    const form = findMainForm();
    const qEl = form ? form.querySelector('[name="quantity"]') : null;
    return qEl ? (parseInt(qEl.value) || 1) : 1;
  }

  function collectItems() {
    const items = [];
    const mainId = getMainVariantId();
    if (!mainId) return items;

    if (dealChecked) {
      // 2+1 gratis: vaste 3 stuks, GEEN _bundle-property (bundelkorting vervalt),
      // dus de discount-functie laat deze regel met rust en de automatische
      // "Koop 2, krijg 1 gratis"-korting van Shopify doet het werk.
      items.push({
        id: mainId,
        quantity: DEAL_QTY,
        properties: { _deal: '2plus1' }
      });
      return items.concat(addonItems());
    }

    // Hoofdproduct wordt als bundel-item getagd zodat de discount-functie het
    // kan meenemen in de prijs-ranking.
    items.push({ id: mainId, quantity: mainQuantity(), properties: { _bundle: 'true' } });
    slots.forEach(s => {
      if (!s.checked) return;
      const d = allCards[s.index];
      if (d && d.variantId) items.push({ id: d.variantId, quantity: 1, properties: { _upsell: 'true' } });
    });
    return items.concat(addonItems());
  }

  function updateCartCount(cart, sideCartDoc) {
    const totalQty = sideCartDoc?.querySelector('[data-totalqty]')?.dataset.totalqty || cart.item_count;
    const totalPrice = sideCartDoc?.querySelector('[data-totalprice]')?.dataset.totalprice;
    document.querySelectorAll('#cart-count,[data-cart-count],[data-cart-item-count],.cart-count,.cart__count,.header__cart-count,.cart-count-bubble').forEach(el => {
      el.textContent = totalQty;
      el.setAttribute('data-count', totalQty);
      if (parseInt(totalQty, 10) > 0) el.removeAttribute('hidden');
    });
    if (totalPrice) {
      document.querySelectorAll('#cart-total,[data-cart-total]').forEach(el => { el.textContent = totalPrice; });
    }
  }

  function refreshDrawerContent(addResponse) {
    const sideCartContainer = document.getElementById('cart');
    const sideCartHtml = addResponse?.sections?.['side-cart'];
    if (!sideCartContainer || !sideCartHtml) return Promise.resolve(null);
    const sideCartDoc = new DOMParser().parseFromString(sideCartHtml, 'text/html');
    const sideCartSection = sideCartDoc.querySelector('#shopify-section-side-cart');
    if (!sideCartSection) return Promise.resolve(null);
    sideCartContainer.innerHTML = sideCartSection.innerHTML;
    window.dispatchEvent(new CustomEvent('modulePanel'));
    window.dispatchEvent(new CustomEvent('listCart'));
    window.dispatchEvent(new CustomEvent('semanticInput'));
    window.dispatchEvent(new CustomEvent('formValidate'));
    window.dispatchEvent(new CustomEvent('accordeon'));
    if (window.ajaxCart && typeof window.ajaxCart.init === 'function') window.ajaxCart.init();
    return Promise.resolve(sideCartDoc);
  }

  function openCartDrawer() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load(false, true, false, false);
      return;
    }
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      if (typeof drawerEl.open === 'function') { drawerEl.open(); return; }
      drawerEl.setAttribute('open', ''); drawerEl.removeAttribute('aria-hidden'); return;
    }
    for (const sel of ['a[data-panel="cart"]','[data-cart-toggle]','[data-drawer-trigger="cart"]','.js-drawer-open-cart','#cart-icon-bubble','[aria-label*="winkelwagen" i]','.cart-toggle','.cart__toggle','.header__cart','.site-header__cart','[aria-label*="warenkorb" i]','[aria-label*="panier" i]']) {
      const el = document.querySelector(sel);
      if (el) { el.click(); return; }
    }
    for (const [name, target] of [['CartDrawer:open', document.body],['cart:open', document],['cart:toggle', document],['theme:cart:open', document],['open-cart', document],['cartOpen', document]]) {
      target.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    }
  }

  function afterAddUI(addResponse, items) {
    return Promise.all([
      fetch(ROOT + 'cart.js').then(r => r.json()).catch(() => null),
      refreshDrawerContent(addResponse).catch(() => null)
    ]).then(([cart, sideCartDoc]) => {
      try {
        if (cart) updateCartCount(cart, sideCartDoc);
        document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.dispatchEvent(new CustomEvent('cart-update', { bubbles: true, detail: { cart } }));
        document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { cart } }));
      } catch (uiErr) { console.error('Upsell UI-fout:', uiErr); }
      openCartDrawer(); // drawer opent PAS nadat alles is toegevoegd
    });
  }

  function addBundleToCart() {
    const items = collectItems();
    if (!items.length) return Promise.resolve();
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items,
        // Interne waarde blijft Nederlands, zodat rapportages over alle talen gelijk zijn.
        attributes: { 'Upsell gebruikt': dealChecked ? 'henk-2plus1' : 'henk-upsell' },
        sections: 'side-cart',
        sections_url: window.location.pathname
      })
    })
    .then(r => { if (!r.ok) return r.json().then(e => { throw new Error(e.message || ('HTTP ' + r.status)); }); return r.json(); })
    .then(addResponse => afterAddUI(addResponse, items))
    .catch(err => {
      console.error('Upsell cart fout:', err);
      alert(t('error') || 'Er ging iets mis bij het toevoegen. Probeer het opnieuw.');
    });
  }

  // Herkennen van winkelwagen-knoppen.
  const ATC_BROAD  = '[name="add"], button[type="submit"], input[type="submit"], .product-form__submit, .add-to-cart, .add_to_cart, [data-add-to-cart], [data-add-to-cart-trigger], .product-form__cart-submit, .btn-addtocart, .btn--add-to-cart';
  const ATC_STRICT = '[name="add"], .product-form__submit, .add-to-cart, .add_to_cart, [data-add-to-cart], [data-add-to-cart-trigger], .product-form__cart-submit, .btn-addtocart, .btn--add-to-cart';

  // Knopteksten in NL / DE / FR / EN.
  const ATC_TEXT = /in\s*winkelwagen|toevoegen|add to cart|in\s*den\s*warenkorb|hinzuf(ü|ue)gen|ajouter/i;

  function isMainTrigger(btn) {
    const form = btn.closest('form[action*="/cart/add"]');
    if (form) {
      const idInput = form.querySelector('[name="id"]');
      const formId = idInput && idInput.value ? String(idInput.value) : '';
      return !formId || isOwnVariant(formId);   // knop van een ander product? niet overnemen
    }
    // Geen cart-form (sticky balk): alleen echte ATC-knoppen accepteren.
    return btn.matches(ATC_STRICT) || ATC_TEXT.test((btn.textContent || '').trim());
  }

  let isAdding = false;
  function takeOver(e, btn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (isAdding) return;
    isAdding = true;
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none'; btn.style.opacity = '0.75'; }
    addBundleToCart().finally(() => {
      isAdding = false;
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.style.pointerEvents = ''; btn.style.opacity = ''; if (original) btn.innerHTML = original; }
    });
  }

  window.addEventListener('click', function (e) {
    if (!hasCheckedAddons()) return;
    const btn = e.target.closest && e.target.closest(ATC_BROAD);
    if (!btn) return;
    if (!isMainTrigger(btn)) return;
    takeOver(e, btn);
  }, true);

  window.addEventListener('submit', function (e) {
    if (!hasCheckedAddons()) return;
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    const idInput = form.querySelector('[name="id"]');
    const formId = idInput && idInput.value ? String(idInput.value) : '';
    if (formId && !isOwnVariant(formId)) return; // ander product
    takeOver(e, form.querySelector(ATC_BROAD));
  }, true);
});
